// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".dddb9d7f58a360ea8e6e26e5fbb88314c5917524.chunk.bundle.js";
};